import { useCallback } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

import useBlueprintsAnalytics from "../../hooks/useBlueprintsAnalytics";

const BlueprintsTableDescriptionCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const trackAnalytics = useBlueprintsAnalytics();

  const handleShowFullDescription = useCallback(() => {
    trackAnalytics("Show full description clicked");
  }, [trackAnalytics]);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription
        description={blueprint.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </TableSimpleCell>
  );
};

export default BlueprintsTableDescriptionCell;
